import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import ConsentText from 'models/gdpr/Consent';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import CurrentUserInfo from 'models/user/CurrentUserInfo';
import ErrorToolTipView from 'views/utils/ErrorToolTipView';
import ChangesSavedView from 'views/device/ChangesSavedView';
import ModelSynchronizer from 'utils/ModelSynchronizer';
import LocaleMapper from 'utils/LocaleMapper';
import GdprUtil from 'utils/gdpr/GdprUtil';
import templateHtml from 'views/gdpr/templates/gdprModalDeleteConfirmation.html';

export default Backbone.View.extend({
    template: _.template(templateHtml),

    events: {
        'focus #passwordConfirm': 'onPasswordFieldFocus'
    },

    initialize: function(args) {
        this.consentType = args.consentType;
        this.modalTopTitle = args.modalTopTitle;
        this.customCancelText = args.customCancelText;
        this.footerPrimaryButtonClasses = args.footerPrimaryButtonClasses;
        this.footerSecondaryButtonClasses = args.footerSecondaryButtonClasses;

        this.language = LocaleMapper.getFullLocale(ViewerUserPreferences.get('preferredLocale'));

        this.gdprConsentText = new ConsentText({
            consentTypeId: this.consentType,
            locale: this.language
        });
        this.currentUserInfo = new CurrentUserInfo();
    },

    render: function() {
        var modelSynchronizer = new ModelSynchronizer();

        modelSynchronizer.addModel({ model: this.gdprConsentText, required: true });
        modelSynchronizer.addModel({ model: this.currentUserInfo, required: true, countError: true });
        modelSynchronizer.on(ModelSynchronizer.Events.SYNCHRONIZED, this.getDeleteConfirmModal, this);
        modelSynchronizer.fetchModels();
    },

    getDeleteConfirmModal: function() {
        this.consentText = this.gdprConsentText.attributes[0];

        var modalTitle,
            modalBody,
            saveBtn,
            cancelBtn,
            footerLink,
            footerTextLink,
            footerPrimaryButtonClasses,
            footerSecondaryButtonClasses,
            userEmail;

        modalTitle = this.consentText.headline;
        modalBody = GdprUtil.getGdprContentText(this.consentText.consentCopyBlocks, null, true);
        saveBtn = this.consentText.grantButton;
        cancelBtn = this.consentText.rejectButton;
        footerLink = this.consentText.revokeLinks.length > 0 ? this.consentText.revokeLinks[0].url : '';
        footerTextLink = this.getFooterTextLink(this.consentText.consentLinks);
        footerPrimaryButtonClasses = this.footerPrimaryButtonClasses ? this.footerPrimaryButtonClasses : '';
        footerSecondaryButtonClasses = this.footerSecondaryButtonClasses ? this.footerSecondaryButtonClasses : '';
        userEmail = this.currentUserInfo ? this.currentUserInfo.get('emailAddress') : '';

        this.$el.html(
            this.template({
                Localizer: Localizer,
                modalTopTitle: this.modalTopTitle,
                modalTitle: modalTitle,
                modalBody: modalBody,
                saveBtn: saveBtn,
                cancelBtn: this.customCancelText ? this.customCancelText : cancelBtn,
                footerLink: footerLink,
                footerTextLink: footerTextLink,
                footerPrimaryButtonClasses: footerPrimaryButtonClasses,
                footerSecondaryButtonClasses: footerSecondaryButtonClasses,
                userEmail: userEmail
            })
        );
    },

    getFooterTextLink: function(footerTextLink) {
        if (footerTextLink.length) {
            return footerTextLink[0].text;
        }
        return '';
    },

    getConsentVersion: function() {
        return this.consentText.version;
    },

    getPassword: function() {
        return document.getElementById('passwordConfirm').value;
    },

    // Clear any error tooltips when the user interacts with the password field
    onPasswordFieldFocus: function() {
        if (this.errorToolTipView) {
            this.errorToolTipView.hide();
        }
    },

    // Scenario: user entered didn't enter a password
    onPasswordEntryFail: function() {
        this.onPasswordFieldFocus();

        this.errorToolTipView = new ErrorToolTipView({
            el: this.$('#passwordConfirm'),
            container: this.$('.modal-body'),
            content: Localizer.localize('password_is_required'),
            placement: 'right'
        });

        this.errorToolTipView.show();
    },

    // Scenario: user entered incorrect password
    onPasswordConfirmFail: function() {
        this.onPasswordFieldFocus();

        this.errorToolTipView = new ErrorToolTipView({
            el: this.$('#passwordConfirm'),
            container: this.$('.modal-body'),
            content: Localizer.localize('enter_valid_password'),
            placement: 'right'
        });

        this.errorToolTipView.show();
    },

    // Scenario: network or server error
    onPasswordConfirmNetworkFail: function() {
        this.networkErrorView = new ChangesSavedView({
            el: this.$('.errorMessagePlaceHolder'),
            message: 'something_went_wrong',
            alertType: 'error'
        });

        this.networkErrorView.render();
    },

    // Scenario: authorization error(missing or invalid password token, data present in the account that requires user auth to delete)
    onAuthorizationFail: function() {
        this.passwordErrorView = new ChangesSavedView({
            el: this.$('.errorMessagePlaceHolder'),
            message: 'something_went_wrong_retry_password',
            alertType: 'error'
        });

        this.passwordErrorView.render();
    }
});
